import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useTranslation } from '../../hooks/useTranslation';

interface PointsRedemptionProps {
  customerPoints?: number;
  totalAmount?: number;
  disabled?: boolean;
}

export const PointsRedemption: React.FC<PointsRedemptionProps> = ({
  customerPoints = 0,
  totalAmount = 0,
  disabled = false,
}) => {
  const { translate } = useTranslation();
  const { register } = useFormContext();

  return (
    <div className="space-y-2">
      <Label htmlFor="pointsRedemption">
        {translate('pos.orders.fields.pointsRedemption')}
      </Label>
      <Input
        id="pointsRedemption"
        type="number"
        min="0"
        placeholder={translate('pos.orders.messages.pointsRedemptionHelp')}
        disabled={disabled}
        {...register('pointsRedemption', { valueAsNumber: true })}
      />
      <p className="text-xs text-muted-foreground">
        {translate('pos.orders.messages.pointsRedemptionHelp')}
      </p>
    </div>
  );
};
